import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './leaveStyle.css';
import config from '../../config.json';
import LeaveLabel from './LeaveLabel';

const apiUrl = config.apiUrl;

const LeaveDetails = () => {
    const [leaveDetails, setLeaveDetails] = useState({
        TransactionID: '',
        TransactionDate: '',
        Employee: [],
        LeaveType: '',
        DateStart: '',
        DateEnd: '',
        Duration: '',
        Remarks: '',
        Status: '',
        CreatedBy: '',
        CreatedDate: '',
        ApprovedBy: '',
        ApprovedDate: '',
        UpdatedBy: '',
        UpdatedDate: '',
    });

    const { leaveId } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchLeaveData = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/Leave/${leaveId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch leave data');
                    setSuccessMessage('');
                    return;
                }
                const data = await response.json();
                setLeaveDetails({
                    TransactionID: data.Details.TransactionID,
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    LeaveType: data.Details.LeaveType,
                    DateStart: data.Details.DateStart,
                    DateEnd: data.Details.DateEnd,
                    Duration: data.Details.Duration,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                    CreatedBy: data.Details.CreatedBy,
                    CreatedDate: data.Details.CreatedDate,
                    ApprovedBy: data.Details.ApprovedBy,
                    ApprovedDate: data.Details.ApprovedDate,
                    UpdatedBy: data.Details.UpdatedBy,
                    UpdatedDate: data.Details.UpdatedDate,
                });
            } catch (error) {
                setErrorMessage('Error fetching leave data');
                setSuccessMessage('');
            }
        };

        fetchLeaveData();
    }, []);

    const {
        TransactionID,
        TransactionDate,
        Employee,
        LeaveType,
        DateStart,
        DateEnd,
        Duration,
        Remarks,
        Status,
        CreatedBy,
        CreatedDate,
        ApprovedBy,
        ApprovedDate,
        UpdatedBy,
        UpdatedDate,
    } = leaveDetails;

    return (
        <div>
            {userAccess.hasView ? (
                <>
                    <h3>View Leave</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <div className="row mt-4">
                        <LeaveLabel label="Transaction ID" value={TransactionID} />
                        <LeaveLabel label="Transaction Date" value={TransactionDate} />
                        <LeaveLabel label="Employee" value={Employee.Name} />
                        <LeaveLabel label="Leave Type" value={LeaveType} />
                        <LeaveLabel label="Date Start" value={DateStart} />
                        <LeaveLabel label="Date End" value={DateEnd} />
                        <LeaveLabel label="Duration" value={Duration} />
                        <LeaveLabel label="Remarks" value={Remarks} />
                        <LeaveLabel label="Status" value={Status} />
                        <LeaveLabel label="CreatedBy" value={CreatedBy} />
                        <LeaveLabel label="CreatedDate" value={CreatedDate} />
                        <LeaveLabel label="UpdatedBy" value={UpdatedBy} />
                        <LeaveLabel label="UpdatedDate" value={UpdatedDate} />
                        <LeaveLabel label="ApprovedBy" value={ApprovedBy} />
                        <LeaveLabel label="ApprovedDate" value={ApprovedDate} />

                        <div className="mb-2">
                            <Link to="/leave-list" className="btn btn-secondary">Back</Link>
                            {(userAccess.hasStandard || userAccess.hasAdmin) && (
                                <Link
                                    to={`/leave-update/${leaveId}`}
                                    className={`btn btn-primary ms-2 ${Status === 'Approved' || Status === 'Rejected' ? 'disabled' : ''}`}
                                >
                                    Edit
                                </Link>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default LeaveDetails;
